/**
 * Created by mac on 2/25/20
 */

const OpenCards = function (level, save, extraSlotUsed) {
    cleverapps.EventEmitter.call(this);

    this.counter = new Counter();
    if (cleverapps.config.type === "tile3") {
        this.counter.registerStage(0, this.explode.bind(this));
    }

    this.counter.registerStage(1, () => {
        Game.currentGame.counter.trigger();
    });

    this.cards = [];
    this.toExplode = [];

    this.limit = OpenCards.getDefaultLimit();
    if (extraSlotUsed) {
        this.incLimit();
    }

    if (save) {
        this.loadSave(save);
    }
    this.getView = function () {};
};

OpenCards.prototype = Object.create(cleverapps.EventEmitter.prototype);
OpenCards.prototype.constructor = OpenCards;

OpenCards.prototype.getCardPosition = function (card) {
    const position = {};

    const view = this.getView();
    if (!view) {
        return position;
    }

    position.parent = view;
    const index = this.cards.indexOf(card);
    position.point = view.findPosForCard(index);
    return position;
};

OpenCards.prototype.loadSave = function (data) {
    data.forEach((item) => {
        const card = TileFactory.Create(item, {
            noMark: true
        });
        card.visibleIndex = item.visibleIndex;
        this.addCard(card, card.visibleIndex);
        card.flip();
    });
};

OpenCards.prototype.getInfo = function () {
    return this.cards.map((card) => card.toJSON());
};

OpenCards.prototype.addExtraSlot = function () {
    this.extraSlot = new ExtraSlot(this);
    this.trigger("addExtraSlot", this.extraSlot);
    this.checkWarning();
};

OpenCards.prototype.incLimit = function () {
    this.limit += 1;
};

OpenCards.prototype.explode = function () {
    if (!this.toExplode.length) {
        return;
    }
    const toExplode = this.toExplode.splice(-3);
    const index = this.cards.indexOf(toExplode[0]);
    const isLast = Game.currentGame.table.isEmpty() && this.cards.length === 3;
    this.cards.splice(index, 3);
    this.trigger("explode", toExplode, isLast);
    const delay = isLast ? 0.8 : 0;

    this.counter.setTimeout(() => {
        const needReindex = this.cards.some((card) => card.visibleIndex !== index);
        if (needReindex) {
            this.reindex();
            this.counter.setTimeout(() => {}, this.getReindexTimeout(3) * 1000 + 50);
        }
    }, (delay + Card.EXPLODE_TIMEOUT) * 1000);

    Game.currentGame.log.clear();
};

OpenCards.prototype.isExploding = function (card) {
    return this.toExplode.indexOf(card) !== -1;
};

OpenCards.prototype.checkOverflow = function () {
    if (this.counter.isActive()) {
        return;
    }

    if (this.isFull()) {
        this.trigger("overflow");
        return true;
    }
    this.checkWarning();
};

OpenCards.prototype.checkWarning = function () {
    this.trigger("warning", this.isWarning());
};

OpenCards.prototype.isWarning = function () {
    return this.cards.length >= this.limit - 2;
};

OpenCards.prototype.getReindexTimeout = function (deltaIndex) {
    return (deltaIndex + 3) / 3 * 0.1;
};

OpenCards.prototype.reindex = function () {
    for (let i = 0; i < this.cards.length; i++) {
        if (this.cards[i].visibleIndex !== i) {
            const timeout = this.getReindexTimeout(Math.abs(this.cards[i].visibleIndex - i));
            this.cards[i].visibleIndex = i;
            this.moveToOpen(this.cards[i], timeout);
        }
    }
};

OpenCards.prototype.moveToOpen = function (card, duration, fromTable) {
    card.trigger("moveToOpen", duration, fromTable);
};

OpenCards.prototype.isEmpty = function () {
    return this.cards.length === 0;
};

OpenCards.prototype.isFull = function () {
    return this.cards.length === this.limit;
};

OpenCards.prototype.canPlay = function (card) {
    return !this.isFull() && card.canPlay();
};

OpenCards.prototype.acceptCard = function (card) {
    card.collectMarksAndComponents();
    if (!card.isOpen()) {
        card.flip();
    }

    const flyDuration = Math.max((card.y + 600) / 3000, 0.1) + 0.2;
    let index = this.cards.length;

    for (let i = index - 1; i >= 0; i--) {
        if (this.cards[i].value === card.value && !this.isExploding(this.cards[i])) {
            index = i + 1;

            if (this.cards[i - 1] && this.cards[i - 1].value === card.value && !this.isExploding(this.cards[i - 1])) {
                this.toExplode = [this.cards[i - 1], this.cards[i], card].concat(this.toExplode);
            }
            break;
        }
    }
    if (index !== this.cards.length) {
        cleverapps.timeouts.setTimeout(this.reindex.bind(this), Math.max(flyDuration - this.getReindexTimeout(1), 0) * 1000);
    }

    this.addCard(card, index);

    this.moveToOpen(card, flyDuration, true);
    this.counter.setTimeout(() => {}, (flyDuration + 0.05) * 1000);
};

OpenCards.prototype.addCard = function (card, index) {
    index = index || this.cards.length;
    this.cards.splice(index, 0, card);
    card.visibleIndex = index;
    card.setOwner(this);
};

OpenCards.prototype.cardClicked = function () {
    if (cleverapps.config.debugMode && !this.counter.isActive() && !this.isFull()) {
        const game = Game.currentGame;

        const table = game.table;
        const cards = table.cards;

        for (let i = cards.length - 1; i >= 0; i--) {
            const card = cards[i];

            if (!card.isOpen() || card.feature === "safe" || card.feature === "streak") {
                continue;
            }

            const plateOnCard = card.findComponent(PlateOnCard);
            if (plateOnCard) {
                plateOnCard.collect();
            }

            if (typeof FlagsOnCard !== "undefined") {
                const flagsOnCard = card.findComponent(FlagsOnCard);
                flagsOnCard && flagsOnCard.destroy();
            }

            if (typeof IceOnCard !== "undefined") {
                const iceOnCard = card.findComponent(IceOnCard);
                iceOnCard && iceOnCard.destroy();
            }

            table.startPlayCard(card);

            break;
        }
    }
    return false;
};

OpenCards.prototype.shift3Cards = function () {
    const cards = this.cards.splice(0, 3);
    if (!cards) {
        return;
    }
    cards.forEach((card) => {
        card.setOwner(Game.currentGame.table);
        this.trigger("pop", card);
    });
    cleverapps.timeouts.setTimeout(this.reindex.bind(this), this.getReindexTimeout(3) * 1000);
    return cards;
};

OpenCards.prototype.pop = function (move) {
    const value = move.options.value;

    let index = undefined;
    for (let i = this.cards.length - 1; i >= 0; i--) {
        if (this.cards[i].value === value) {
            index = i;
            break;
        }
    }

    if (index === undefined) {
        return;
    }

    const card = this.cards[index];
    this.cards.splice(index, 1);
    cleverapps.timeouts.setTimeout(this.reindex.bind(this), this.getReindexTimeout(1) * 1000);
    card.setOwner(Game.currentGame.table);
    this.trigger("pop", card);
    return card;
};

OpenCards.prototype.clear = function () {
    this.cards.forEach((card) => {
        card.clear();
    });
    this.cards = [];
};

OpenCards.prototype.hide = function () {
    this.trigger("hide");
};

OpenCards.prototype.getCurrentCard = function () {
    if (this.cards.length === 0) {
        return undefined;
    }

    return this.cards[this.cards.length - 1];
};

OpenCards.prototype.hasExtraSlot = function () {
    return this.limit > OpenCards.getDefaultLimit();
};

OpenCards.getDefaultLimit = function () {
    return cleverapps.gameModes.threeOpenCards ? 3 : 7;
};

OpenCards.OVERFLOW_ANIMATION_DURATION = 500;